import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DashboardService } from '../../../service/DashboardService';
import QuestionImage from '../../../components/QuestionImage';

const dashboardService = new DashboardService();

const sourceLabel = { quiz: 'Quiz', practiceTest: 'Simulado' };

// Aberto ao clicar numa célula do heatmap por aluno (ModulePerformanceHeatmap/
// TestPerformanceHeatmap) — mostra as questões que geraram aquela célula
// (módulo ou prova + semana específica), com certo/errado. `source` vem do
// gráfico (Quiz ou Simulado) que foi clicado, pra bater com o total que o
// tooltip daquele gráfico especificamente mostrou — sem isso o modal juntava
// Quiz + Simulado e o total nunca batia com o tooltip de um só tipo.
export const HeatmapCellDetailDialog = ({ visible, onHide, userId, moduleId, testId, period, source, cellLabel }) => {
    const [items, setItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!visible) return;
        setLoading(true);
        setError(null);
        setItems(null);
        dashboardService.getHeatmapCellDetail(userId, { moduleId, testId, period, source })
            .then(res => setItems(res || []))
            .catch(() => setError('Não foi possível carregar as questões.'))
            .finally(() => setLoading(false));
    }, [visible, userId, moduleId, testId, period, source]);

    return (
        <Dialog
            header={cellLabel ? `Questões (${sourceLabel[source] || source}) — ${cellLabel}` : 'Questões respondidas'}
            visible={visible}
            onHide={onHide}
            style={{ width: '40rem', maxWidth: '95vw' }}
        >
            {loading ? (
                <div className="flex justify-content-center p-5">
                    <ProgressSpinner />
                </div>
            ) : error ? (
                <p>{error}</p>
            ) : !items || items.length === 0 ? (
                <p className="text-color-secondary">Nenhuma questão encontrada nessa semana.</p>
            ) : (
                <div>
                    {items.map((item, index) => (
                        // Cor fixa (não var(--green-*)/var(--red-*), que no dark
                        // theme mantêm o mesmo tom claro do light theme mas o
                        // texto herda a cor clara do tema, ficando ilegível) —
                        // mesmo par usado nos badges "Ativo"/"Inativo" e no
                        // Gabarito do Timeline.
                        <div
                            key={`${item.source}-${item.questionId}-${index}`}
                            className="mb-3 p-2 border-round"
                            style={
                                item.isCorrect
                                    ? { border: '2px solid #256029', background: '#C8E6C9', color: '#256029' }
                                    : { border: '1px solid #C63737', background: '#FFCDD2', color: '#C63737' }
                            }
                        >
                            <div className="flex align-items-center gap-2 mb-2">
                                <span className="text-xs font-medium">{sourceLabel[item.source] || item.source}</span>
                                <i className={item.isCorrect ? 'pi pi-check-circle' : 'pi pi-times-circle'} />
                            </div>
                            <div className="text-center mb-2">
                                <QuestionImage questionId={item.questionId} type="main" width={160} />
                            </div>
                            {item.questionTitle && (
                                <p className="m-0 mb-1"><strong>{item.questionTitle}</strong></p>
                            )}
                            <p className="m-0 mb-2" style={{ whiteSpace: 'pre-wrap' }}>{item.description}</p>
                            <div className="text-sm">
                                Resposta: {item.selectedChoiceDescription || 'Não respondida'}
                            </div>
                            {!item.isCorrect && (
                                <div className="text-sm mt-1">
                                    Resposta correta: {item.correctChoiceDescription || '—'}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </Dialog>
    );
};

export default HeatmapCellDetailDialog;
